import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import VM from 'scratch-vm';
import BrainScienceComponent from '../components/brain-science/brain-science.jsx';


class BrainScience extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
            'handleModalClose'
        ]);
    }

    //关闭弹层
    handleModalClose() {
        //关闭前 先清除定时器，然后再关闭弹层
        this.props.vm.runtime.ioDevices.Aixiong.clearBrainChartTimer();
        this.props.onRequestClose();
    }

    render() {
        
        return (
            <BrainScienceComponent
                id="brainScience"
                title='脑电参数检测'
                brainScienceData={this.props.brainScienceData}
                onRequestClose={this.handleModalClose}
            />
        );
    }
}

BrainScience.propTypes = {
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(BrainScience);
